import { FC, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@src/lib/ui/Accordion";
import { Dialog, DialogContent, DialogTitle } from "@src/lib/ui/Dialog";
import Text from "@src/lib/ui/Text";

export const WHATS_CHANGING_SECTIONS: {
  value: string;
  title: string;
  body: string;
  image: string;
}[] = [
  {
    value: "at-launch",
    title: "Your team gets Newsfeed and Messages in the Opus app",
    body: "On your launch date, Newsfeed shows up on everyone’s Home screen and Messages gets its own tab.",
    image: "/images/comms-opt-in/whats-changing-launch.jpg",
  },
  {
    value: "company-updates",
    title: "Company updates in the Newsfeed",
    body: "Post announcements, policy reminders, and urgent updates to the Locations, Roles, or people they’re for.",
    image: "/images/comms-opt-in/whats-changing-updates.jpg",
  },
  {
    value: "messages",
    title: "Messages for conversations",
    body: "Ask in a group message, where the people who can help will see it. Send a direct message to check in with one person.",
    image: "/images/comms-opt-in/whats-changing-messages.jpg",
  },
  {
    value: "permissions",
    title: "Choose who can post and message",
    body: "Turn on posting and messaging for whole Roles, or for one person at a time. Admins can always do both.",
    image: "/images/comms-opt-in/whats-changing-permissions.jpg",
  },
];

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const WhatsChangingDialog: FC<Props> = ({ open, onOpenChange }) => {
  const [openValue, setOpenValue] = useState(WHATS_CHANGING_SECTIONS[0].value);
  const openSection =
    WHATS_CHANGING_SECTIONS.find((section) => section.value === openValue) ??
    WHATS_CHANGING_SECTIONS[0];
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) setOpenValue(WHATS_CHANGING_SECTIONS[0].value);
        onOpenChange(next);
      }}
    >
      <DialogContent
        hideDefaultTitle
        className="flex h-163 max-h-full w-280 gap-0 overflow-hidden p-0"
      >
        <div className="flex w-105 shrink-0 flex-col gap-4 overflow-y-auto p-5">
          <DialogTitle size="large">What&apos;s changing</DialogTitle>
          <Accordion
            type="single"
            value={openValue}
            onValueChange={(value) => value && setOpenValue(value)}
            className="border-t border-border-primary"
          >
            {WHATS_CHANGING_SECTIONS.map((section) => (
              <AccordionItem key={section.value} value={section.value}>
                <AccordionTrigger className="py-3.5 data-[state=open]:pb-1.5">
                  {section.title}
                </AccordionTrigger>
                <AccordionContent className="pb-3.5">
                  <Text
                    variant="compact-description"
                    multiline
                    className="text-text-secondary"
                  >
                    {section.body}
                  </Text>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <img
          src={openSection.image}
          alt=""
          className="min-w-0 flex-1 bg-bg-tertiary object-cover"
        />
      </DialogContent>
    </Dialog>
  );
};

export default WhatsChangingDialog;
